
import React, { FC } from "react";

interface Industry {
  title: string;
  icon: string;
  image: string;
}

const TrustStrip: FC = () => {
  const industries: Industry[] = [
    {
      title: "Medspas & Aesthetic Clinics",
      icon: "ri-heart-pulse-line",
      image:
        "https://public.readdy.ai/ai/img_res/b55b97ab35945c536393b47fd125f162.jpg",
    },
    {
      title: "Attorneys & Legal Practices",
      icon: "ri-scales-3-line",
      image:
        "https://readdy.ai/api/search-image?query=elegant%20law%20office%20desk%20with%20premium%20leather%20bound%20legal%20books%20and%20silver%20pen%20on%20dark%20polished%20wood%20surface%20sophisticated%20professional%20atmosphere%20with%20warm%20ambient%20lighting%20and%20shallow%20depth%20of%20field%20minimal%20luxury%20aesthetic&width=400&height=400&seq=trust-law-01&orientation=squarish",
    },
    {
      title: "Real Estate Teams & Brokerages",
      icon: "ri-building-4-line",
      image:
        "https://readdy.ai/api/search-image?query=aerial%20view%20of%20luxury%20modern%20architectural%20building%20with%20glass%20facades%20reflecting%20silver%20sky%20at%20twilight%20premium%20real%20estate%20property%20with%20clean%20geometric%20lines%20and%20sophisticated%20urban%20design%20dark%20moody%20atmosphere%20with%20metallic%20accents&width=400&height=400&seq=trust-realestate-01&orientation=squarish",
    },
  ];

  /** Simple fallback image in case the remote source fails */
  const handleImgError = (
    e: React.SyntheticEvent<HTMLImageElement, Event>
  ) => {
    (e.currentTarget as HTMLImageElement).src =
      "https://via.placeholder.com/400?text=Image+Unavailable";
  };

  return (
    <section className="bg-[#0B0D10] py-28">
      <div className="max-w-7xl mx-auto px-6">
        <p className="text-center text-xs font-semibold tracking-[0.35em] text-[#8C9198] mb-16 uppercase">
          Built for Elite Industries
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {industries.map((industry) => (
            <div
              key={industry.title}
              className="group relative overflow-hidden rounded-2xl cursor-pointer"
            >
              <div className="w-full h-72 overflow-hidden">
                <img
                  src={industry.image}
                  alt={industry.title}
                  onError={handleImgError}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110"
                />
              </div>

              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent"></div>

              <div className="absolute bottom-0 left-0 right-0 p-8">
                <div className="flex items-center gap-3 mb-2">
                  <div className="w-8 h-8 flex items-center justify-center">
                    {/* Tailwind arbitrary opacity works fine inside a template literal */}
                    <i
                      className={`${industry.icon} text-xl text-white/80`}
                      aria-hidden="true"
                    ></i>
                  </div>
                  <h3 className="text-lg font-semibold text-white tracking-tight">
                    {industry.title}
                  </h3>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustStrip;
